export default __webpack_public_path__ + "static/media/selecticon.73b8c7d7.svg";